export const filterObjectKeys = (obj, allowedKeys) => {
  return Object.keys(obj)
    .filter((key) => allowedKeys.includes(key))
    .reduce((acc, key) => ({ ...acc, [key]: obj[key] }), {});
};
